// Shared utility functions

/**
 * Format a Firestore timestamp or Date to a readable string
 * @param {Object|Date|string} timestamp - Firestore timestamp, Date, or ISO string
 * @param {Object} options - Intl.DateTimeFormat options
 * @returns {string} Formatted date string
 */
export const formatDate = (timestamp, options = { month: 'short', day: 'numeric', year: 'numeric' }) => {
  if (!timestamp) return '';
  const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
  return date.toLocaleDateString('en-TT', options);
};

/**
 * Format currency in TT dollars
 * @param {number} amount - Amount to format
 * @returns {string} Formatted currency string
 */
export const formatCurrency = (amount) => {
  return `TT$ ${Number(amount).toLocaleString()}`;
};

/**
 * Get status badge color based on status type
 * @param {string} status - Status string
 * @returns {string} CSS color value
 */
export const getStatusColor = (status) => {
  const colors = {
    // Registration/Order statuses
    pending: '#f59e0b',
    approved: '#22c55e',
    rejected: '#ef4444',
    waitlist: '#3b82f6',
    // Order specific
    paid: '#22c55e',
    processing: '#3b82f6',
    shipped: '#8b5cf6',
    delivered: '#22c55e',
    cancelled: '#ef4444',
    // Announcement types
    info: '#3b82f6',
    success: '#22c55e',
    warning: '#f59e0b',
    urgent: '#ef4444',
  };
  return colors[status?.toLowerCase()] || '#6b7280';
};

// Age groups and teams constants
export const AGE_GROUPS = ['U8', 'U10', 'U12', 'U14', 'U16', 'U18'];
export const TIERS = ['Tier 1', 'Tier 2'];
export const ALL_TEAMS = [...AGE_GROUPS, ...TIERS];

// Trinidad & Tobago regions
export const TT_REGIONS = [
  'Port of Spain', 'San Fernando', 'Chaguanas', 'Arima', 'Point Fortin',
  'Sangre Grande', 'Tunapuna', 'San Juan', 'Couva', 'Diego Martin',
  'Marabella', 'Penal', 'Siparia', 'Rio Claro', 'Princes Town',
  'Scarborough', 'Fyzabad', 'La Brea', 'Gasparillo', 'Cunupia'
];

// Player positions
export const POSITIONS = ['Goalkeeper', 'Defender', 'Midfielder', 'Forward'];

// Event types
export const EVENT_TYPES = ['training', 'match', 'tournament'];

// Product categories
export const PRODUCT_CATEGORIES = ['Jerseys', 'Training', 'Shorts', 'Accessories'];

// Product sizes
export const PRODUCT_SIZES = ['YS', 'YM', 'YL', 'S', 'M', 'L', 'XL', 'XXL', 'One Size'];
